// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t77Vs","clinicsSelect":"styles_clinicsSelect__ZI-zK"};